var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invoice-rd"},[_c('div',{staticClass:"flex flex--col gap-12"},_vm._l((_vm.data),function(slot){return _c('slot-item-table-mobile',{key:slot.treatment,attrs:{"data":slot,"get-date-and-month":_vm.getDateAndMonth,"get-time":_vm.getTime}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bb23079","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/health-advisor-widget/SlotsTableMobile.vue
// module id = bZEN
// module chunks = 0 1 4